import { createContext, type ReactNode, useContext } from 'react';

interface SearchContextType {
  searchString: string;
}

/**
 * Context to provide the search string to all components that need it.
 * This allows us to avoid prop drilling and keep the search string in
 * a single source of truth.
 */
export const SearchContext = createContext<SearchContextType>({
  searchString: '',
});

export const useSearchContext = () => {
  return useContext(SearchContext);
};

interface SearchProviderProps {
  children: ReactNode;
  searchString: string;
}

export const SearchProvider = ({
  children,
  searchString,
}: SearchProviderProps) => {
  return (
    <SearchContext.Provider value={{ searchString }}>
      {children}
    </SearchContext.Provider>
  );
};
